
import React, { useEffect, useState } from "react";
import { Table, Card, Form, Input, Col, Row } from 'antd';
import strings from '../../utils/strings';
import moment from 'moment-jalaali';
import StringHelper from "../helpers/StringHelper";
import { useReportsStore } from "../../store/slices/createReportsSlice";
import { usePersistedStore } from '../../store/persisted-store';

export default function BusinessOtpReport() {
    const reports = useReportsStore()

    const data = reports.otpReport.data.item;
    const loading = reports.otpReport.loading;
    const { business } = usePersistedStore();
    const currentBusiness = business.currentBusiness;
    const { token } = currentBusiness;
    const [filterData, setFilterData] = useState([]);
    const [searchValue, setSearchValue] = useState("");
    const [form] = Form.useForm();

    function handlePaste(event) {
        let paste = (event.clipboardData || window.clipboardData).getData("text");
        paste = paste.split("|").join(",");
        setSearchValue(paste)
    }
    useEffect(() => {
        if (token) {
            reports.getBusinessOtpReport();
            form.resetFields();
        }

    }, [token])
    

    useEffect(() => {
        setFilterData(data)
    }, [data]);

    useEffect(() => {
        if (searchValue === "") return setFilterData(data)
    }, [searchValue]);

    const searchHandlerInput = (event) => {
        const { value } = event.target;
        setSearchValue(value);
        if (value) {
            const filtered = data && data.filter((item) => {
                return strings.getFarsiNum(item.MobileNumber).includes(strings.getFarsiNum(value))
            }
            )
            if (filtered) setFilterData(filtered)
        }
    }
    const columns = [

        {
            title: "شماره موبایل",
            dataIndex: "MobileNumber",
            key: "MobileNumber",
            width: 80,
            render: data => data && strings.getFarsiNum(data)
        },
        {
            title: "متن پیامک",
            dataIndex: "Text",
            key: "Text",
            width: 140,

        },
        {
            title: "تاریخ ارسال",
            dataIndex: "SendDate",
            key: "SendDate",
            width: 110,
            sorter: (a, b) => {
                let first = '';
                let second = '';
                a.SendDate ? first = a.SendDate : first = '';
                b.SendDate ? second = b.SendDate : second = '';
                return first.localeCompare(second)
            },
            render: (text) => text && StringHelper.getFarsiNum(moment(text).format('HH:mm - jYYYY/jM/jD ')),

        },

    ];

    return (
        <Card>
            <Row>
                <Col span={12}>
                    <Form
                        form={form}>
                        <Form.Item
                            onKeyPress={(e) => (e.key === 'Enter' && "")}
                            name="search" label="جستجو">

                            <Input
                                value={searchValue}
                                onPaste={handlePaste}
                                onChange={e => searchHandlerInput(e)}
                                className="table-search"
                                placeholder=" جستجو بر اساس شماره موبایل"
                            />
                        </Form.Item>
                    </Form>
                </Col>
                <Col span={12}>
                    <button type="primary" className="btn btn-primary waves-effect waves-light float-left" htmltype="submit"
                        onClick={() => {
                            reports.getBusinessOtpReport()
                            form.resetFields();
                        }}
                        style={{ marginBottom: "20px" }}>
                        بروزرسانی لیست &nbsp;&nbsp;&nbsp;<i className={loading ? "bx bx-loader bx-spin" : "fas fa-sync-alt"}></i>
                    </button>
                </Col>
            </Row>
            <Table
                style={{ overflowX: 'scroll' }}
                className="custom-table"
                size="small"
                bordered
                columns={columns}
                loading={loading}
                rowKey="Id"
                scroll={true}
                dataSource={filterData}
            />

        </Card>
    );
}


